export enum EVENTS {
    'event' = 'event',
    'request_port' = 'request_port',
    'control_message' = 'control_message',
    'connect' = 'connect',
    'disconnect' = 'disconnect',
    'error' = 'error',
    'connect_error' = 'connect_error',
    'conversation_closed' = 'conversation_closed',
    'welcome_message_request' = 'welcome_message_request',
    'user_message' = 'user_message',
    'agent_message'  = 'agent_message',
    'agent_assist_request' = 'agent_assist_request',
    'agent_assist_response' = 'agent_assist_response',
    'agent_menu_request' = 'agent_menu_request',
    'agent_menu_response' = 'agent_menu_response',
    'agent_assist_user_message' = 'agent_assist_user_message',
    'agent_feedback_request' = 'agent_feedback_request',
    'agent_feedback_response' = 'agent_feedback_response',
    'agent_usage_feedback' = 'agent_usage_feedback',
    'agent_assist_agent_request' = 'agent_assist_agent_request',
    'agent_assist_agent_response' = 'agent_assist_agent_response',
    'agent_assist_endoftask' = 'agent_assist_endoftask',
    'request_resolution_comments' = 'request_resolution_comments',
    'response_resolution_comments' = 'response_resolution_comments',
    'enable_override_userinput' = 'enable_override_userinput',
    'agent_send_or_copy' = 'agent_send_or_copy',
    'end_of_conversation' = 'end_of_conversation',
    'user_sent_message' = 'user_sent_message',
    'agent_sent_message' = 'agent_sent_message',
    'agent_coaching_response' = 'agent_coaching_response',
    'realtime_sentiment_response' = 'realtime_sentiment_response',
    'agent_coaching_ackpress' = 'agent_coaching_ackpress',
    'checklist_opened' = 'checklist_opened',
    'checklist_step_closed' = 'checklist_step_closed',
    'checklist_closed' = 'checklist_closed',
    'checklist_step_response' = 'checklist_step_response',
    'checklist_response' = 'checklist_response',
    'checklist_resume' = 'checklist_resume',
    'checklist_proceed_to_closed' = 'checklist_proceed_to_closed',
    'internal_transfer'= 'internal_transfer',
    'internal_transfer_response' = 'internal_transfer_response',
    'agent_activity_request' = 'agent_activity_request',
    'submit_summary_request' = 'submit_summary_request',
    'agentassist_control_response' = 'agentassist_control_response',
    'response_resolution_comments_ack' = 'response_resolution_comments_ack',
    'desktop_activity_request' = 'desktop_activity_request',
    'settings_response' = 'aa_settings',
    'on_ready' = 'aa_ready',
    'get_summaries' = 'get_summaries',
    'summaries_feedback_response' = 'summaries_feedback_response',
    'summaries_response' = 'summaries_response',
    'prefs_response'='aa_prefs',
    'agent_assist_custom_response' = 'agent_assist_custom_response',
    'agent_assist_custom_request' = 'agent_assist_custom_request',
    'agentic_start' = 'agentic_start',
    'agentic_response' = 'agentic_response',
    'agentic_override' = 'agentic_override',
    'agentic_request' = 'agentic_request',
    'agentic_pause' = 'agentic_pause',
    'agentic_resume' = 'agentic_resume',
    'agentic_end' = 'agentic_end',
    'update_agentic_response' = 'update_agentic_response',
    'agentic_request_ack' = 'agentic_request_ack'
};

export enum SDK_EVENTS  {
    'BEFORE_VIEW_INIT' = 'BEFORE_VIEW_INIT',
    'SUMMARY_TEMPLATE' = 'SUMMARY_TEMPLATE',
    'AGENT_TRANSCRIPT' = 'AGENT_TRANSCRIPT',
    'USER_TRANSCRIPT' = 'USER_TRANSCRIPT',
    'BOT_TRANSCRIPT' = 'BOT_TRANSCRIPT',
    'AGENT_JOINED_TEMPLATE' = 'AGENT_JOINED_TEMPLATE',
    'DIALOG_TEMPLATE' = 'DIALOG_TEMPLATE',
    'ARTICE_TEMPLATE' = 'ARTICLE_TEMPLATE',
    'SNIPPET_TEMPLATE' = 'SNIPPET_TEMPLATE',
    'FILE_TEMPLATE' = 'FILE_TEMPLATE',
    'FAQ_TEMPLATE' = 'FAQ_TEMPLATE',
    'HINT_TEMPLATE' = 'HINT_TEMPLATE',
    'NUDGE_TEMPLATE' = 'NUDGE_TEMPLATE',
    'FOOTER_TEMPLATE' = 'FOOTER_TEMPLATE',
    'HEADER_TEMPLATE' = 'HEADER_TEMPLATE',
    'SEARCH_INPUT' = 'SEARCH_INPUT',
    'FAQ_ANSWER_AFTER_TOGGLE' = 'FAQ_ANSWER_AFTER_TOGGLE',
    'SEARCH_ARTICE_TEMPLATE' = 'SEARCH_ARTICE_TEMPLATE',
    'SEARCH_SNIPPET_TEMPLATE' = 'SEARCH_SNIPPET_TEMPLATE',
    'SEARCH_FILE_TEMPLATE' = 'SEARCH_FILE_TEMPLATE',
    'SEARCH_FAQ_TEMPLATE' = 'SEARCH_FAQ_TEMPLATE',
    'SEARCH_DIALOG_TEMPLATE' = 'SEARCH_DOIALOG_TEMPLATE',
    'CONVERSATION_SUMMARY_TEMPLATE' = 'CONVERSATION_SUMMARY_TEMPLATE',
    'SUMMARY_TEMPLATE_ASSIST' = 'SUMMARY_TEMPLATE_ASSIST',
    'ON_ERROR' = 'ON_ERROR',
    'AGENT_SEND_MESSAGE' = 'AGENT_SEND_MESSAGE',
    'AGENT_COPY_MESSAGE' = 'AGENT_COPY_MESSAGE',
    'PLAYBOOK_HEADER_TEMPLATE' = 'PLAYBOOK_HEADER_TEMPLATE',
    'PLAYBOOK_BODY_TEMPLATE' = 'PLAYBOOK_BODY_TEMPLATE',
    'PLAYBOOK_EMPTY_SCREEN' = 'PLAYBOOK_EMPTY_SCREEN',
    'PLAYBOOK_EMPTY_TEMPLATE' = 'PLAYBOOK_EMPTY_TEMPLATE',
    'PLAYBOOK_SEND_EVENT' = 'PLAYBOOK_SEND_EVENT',
    'PLAYBOOK_COPY_EVENT' = 'PLAYBOOK_COPY_EVENT',
    'PLAYBOOK_CONFIRMATION_YES' = 'PLAYBOOK_CONFIRMATION_YES',
    'PLAYBOOK_CONFIRMATION_NO' = 'PLAYBOOK_CONFIRMATION_NO',
    'PLAYBOOK_PRIMARYLIST_TEMPLATE' = 'PLAYBOOK_PRIMARYLIST_TEMPLATE',
    'PLAYBOOK_DYNAMICLIST_TEMPLATE' = 'PLAYBOOK_DYNAMICLIST_TEMPLATE',
    'PLAYBOOK_STAGE_DROPDOWN_TEMPLATE' = 'PLAYBOOK_STAGE_DROPDOWN_TEMPLATE',
    'PLAYBOOK_TRIGGERED_LIST_TEMPLATE' = 'PLAYBOOK_TRIGGERED_LIST_TEMPLATE',
    'PLAYBOOK_OPENED_EVENT' = 'PLAYBOOK_OPENED_EVENT',
    'PLAYBOOK_RESUME_EVENT' = 'PLAYBOOK_RESUME_EVENT',
    'PLAYBOOK_STEP_CLOSED_EVENT' = 'PLAYBOOK_STEP_CLOSED_EVENT',
    'PLAYBOOK_PROCEED_TO_CLOSE_EVENT' = 'PLAYBOOK_PROCEED_TO_CLOSE_EVENT',
    'MENU_TEMPLATE' = 'MENU_TEMPLATE',
    'ASSIST_EMPTY_TEMPLATE' = 'ASSIST_EMPTY_TEMPLATE',
    'ASSIST_HEADER_LEFT_SECTION' = 'ASSIST_HEADER_LEFT_SECTION',
    'ASSIT_HEADER_RIGHT_SECTION' = 'ASSIST_HEADER_RIGHT_SECTION',
    'FEEDBACK_WRAPER_TEMPLATE' = 'FEEDBACK_WRAPER_TEMPLATE',
    'AUTOMATION_WRAPPER_TEMPLATE' = 'AUTOMATION_WRAPPER_TEMPLATE',
    'DIALOG_START_TEMPLATE' = 'DIALOG_START_TEMPLATE',
    'DIALOG_END_TEMPLATE' = 'DIALOG_END_TEMPLATE',
    'ASK_CUSTOMER_TEMPLATE' = 'ASK_CUSTOMER_TEMPLATE',
    'TELL_CUSTOMER_TEMPLATE' = 'TELL_CUSTOMER_TEMPLATE',
    'WELCOME_MSG_TEMPLATE' = 'WELCOME_MSG_TEMPLATE',
    'TERMINATE_POPUP_TEMPLATE' = 'TERMINATE_POPUP_TEMPLATE',
    'INTERRUPT_POPUP_TEMPLATE' = 'INTERRUPT_POPUP_TEMPLATE',
    'INTERRUPT_DROPDOWN_ITEM_TEMPLATE' = 'INTERRUPT_DROPDOWN_ITEM_TEMPLATE',
    'ASSIST_SUGGESTIONS_TEMPLATE' = 'ASSIST_SUGGESTIONS_TEMPLATE',
    'FAQ_EXPAND_CLOSE_TEMPLATE' = 'FAQ_EXPAND_CLOSE_TEMPLATE',
    'HELPFUL_FEEDBACK_TEMPLATE' = 'HELPFUL_FEEDBACK_TEMPLATE',
    'NEGATIVE_FEEDBACK_TEMPLATE' = 'NEGATIVE_FEEDBACK_TEMPLATE',
    'FEEDBACK_TOAST_TEMPLATE' = 'FEEDBACK_TOAST_TEMPLATE',
    "LIST_VIEW_TEMPLATE" = 'LIST_VIEW_TEMPLATE',
    "MYBOT_EMPTY_TEMPLATE" = 'MYBOT_EMPTY_TEMPLATE',
    'MYBOT_HEADER_LEFT_SECTION' = 'MYBOT_HEADER_LEFT_SECTION',
    'MYBOT_HEADER_RIGHT_SECTION' = 'MYBOT_HEADER_RIGHT_SECTION',
    "TRANSCRIPT_BULB" = "TRANSCRIPT_BULB",
    "SCROLL_UP_BTN" = "SCROLL_UP_BTN",
    "SCROLL_DOWN_BTN" = "SCROLL_DOWN_BTN",
    "DIALOG_WRAPPER" = "DIALOG_WRAPPER",
    "ATTACHMENT_VIEW" = "ATTACHMENT_VIEW",
    "MAIN_CONTAINER" = "MAIN_CONTAINER",
    "MAIN_LOADER" = "MAIN_LOADER",
    "INDIVIDUAL_LOADER" = "INDIVIDUAL_LOADER",
    "SENT_BUTTON_TEMPLATE" = "SENT_BUTTON_TEMPLATE",
    "NETWORK_ERROR_TOASTR" = "NETWORK_ERROR_TOASTR",
    "SETTINGS_TEMPLATE" = "SETTINGS_TEMPLATE",
    "SENTIMENT_POPUP_TEMPLATE" = "SENTIMENT_POPUP_TEMPLATE",
    "RUN_CLICK_EVENT" = "RUN_CLICK_EVENT",
    "TAB_CHANGE_EVENT" = "TAB_CHANGE_EVENT",
    "THEME_CHANGE_EVENT" = "THEME_CHANGE_EVENT",
    "SETTINGS_CLICK_EVENT" = "SETTINGS_CLICK_EVENT",
    "SEARCH_EVENT" = "SEARCH_EVENT",
    "TERMINATE_CLICK_EVENT" = "TERMINATE_CLICK_EVENT",
    "INTERRUPT_CLICK_EVENT" = "INTERRUPT_CLICK_EVENT",
    "LISTVIEW_CLICK_EVENT" = "LISTVIEW_CLICK_EVENT",
    "RESTART_CLICK_EVENT" = "RESTART_CLICK_EVENT",
    "SENTIMENT_EVENT" = "SENTIMENT_EVENT",
    "SUMMARY_POPUP_TEMPLATE" = "SUMMARY_POPUP_TEMPLATE",
    "SUMMARY_PREVIOUS_TEMPLATE" = "SUMMARY_PREVIOUS_TEMPLATE",
    "SUMMARY_FEEDBACK_TEMPLATE" = "SUMMARY_FEEDBACK_TEMPLATE",
    "ENTITY_EXPAND_BTN" = "ENTITY_EXPAND_BTN",
    "ENTITY_REDUCE_BTN" = "ENTITY_REDUCE_BTN",
    "CUSTOM_TAB_HEADER_LEFT_SECTION" = "CUSTOM_TAB_HEADER_LEFT_SECTION",
    "CUSTOM_TAB_HEADER_RIGHT_SECTION" = "CUSTOM_TAB_HEADER_RIGHT_SECTION",
    "CUSTOM_TAB_EMPTY_SECTION" = "CUSTOM_TAB_EMPTY_SECTION",
    "CUSTOM_TAB_DIALOG_WRAPPER" = "CUSTOM_TAB_DIALOG_WRAPPER",
    "CUSTOM_TAB_INTERRUPT_DROPDOWN_ITEM_TEMPLATE" = "CUSTOM_TAB_INTERRUPT_DROPDOWN_ITEM_TEMPLATE",
    "CUSTOM_TAB_SHOW_ALL_DIALOGS" = "CUSTOM_TAB_SHOW_ALL_DIALOGS",
    "CUSTOM_TAB_INTERRUPT_DROPDOWN_ITEM_TEMPLATE_IN_POPUP" = "CUSTOM_TAB_INTERRUPT_DROPDOWN_ITEM_TEMPLATE_IN_POPUP",
    "MORE_OPTIONS_TEMPLATE" = "MORE_OPTIONS_TEMPLATE",
    "OVERALL_FEEDBACK_POPUP_TEMPLATE" = "OVERALL_FEEDBACK_POPUP_TEMPLATE",
    "WIDGET_FEEDBACK_POSITIVE_TEMPLATE" = "WIDGET_FEEDBACK_POSITIVE_TEMPLATE",
    "WIDGET_FEEDBACK_NEGATIVE_TEMPLATE" = "WIDGET_FEEDBACK_NEGATIVE_TEMPLATE",
    "ASSIST_AGENTIC_NODE_TEMPLATE" = "ASSIST_AGENTIC_NODE_TEMPLATE",
    "AGENTIC_EMPTY_TEMPLATE" = "AGENTIC_EMPTY_TEMPLATE",
    "AGENTIC_HEADER_LEFT_SECTION" = "AGENTIC_HEADER_LEFT_SECTION",
    "AGENTIC_HEADER_RIGHT_SECTION" = "AGENTIC_HEADER_RIGHT_SECTION",
    "AGENTIC_OVERRIDE_INPUT_TEMPLATE" = "AGENTIC_OVERRIDE_INPUT_TEMPLATE",
    "AGENTIC_DYNAMIC_SEND_ACTION_BTN_TEMPLATE" = "AGENTIC_DYNAMIC_SEND_ACTION_BTN_TEMPLATE",
    "AGENTIC_SEARCH_RESULTS_TEMPLATE" = "AGENTIC_SEARCH_RESULTS_TEMPLATE"
}

export enum DATA_EVENTS {
    'AGENT_COACHING_RESPONSES' = 'AGENT_COACHING_RESPONSES',
    'USER_TRANSCRIPT_RESPONSE' = 'USER_TRANSCRIPT_RESPONSE',
    'AGENT_TRANSCRIPT_RESPONSE' = 'AGENT_TRANSCRIPT_RESPONSE',
    'AGENT_AI_RESPONSE' = 'AGENT_AI_RESPONSE',
    'AGENT_AI_AGENT_RESPONSE' = 'AGENT_AI_AGENT_RESPONSE',
    'PRO_ACTIVE_CHANGE' = 'PRO_ACTIVE_CHANGE',
    'RESOLUTION_COMMENTS_RESPONSE' = 'RESOLUTION_COMMENTS_RESPONSE',
    'CHECKLIST_RESPONSE' = 'CHECKLIST_RESPONSE',
    'CHECKLIST_STEP_RESPONSE' = 'CHECKLIST_STEP_RESPONSE',
    'AGENT_AI_MENU_RESPONSE' = 'AGENT_AI_MENU_RESPONSE',
    'END_OF_TASK_RESPONSE' = 'END_OF_TASK_RESPONSE',
    'AGENT_ASSIST_USER_MESSAGE' = 'AGENT_ASSIST_USER_MESSAGE',
    'AGENT_FEEDBACK_RESPONSE' = 'AGENT_FEEDBACK_RESPONSE',
    'CALL_CONVERSATION_SUGGESTIONS' = 'CALL_CONVERSATION_SUGGESTIONS',
    'AUTO_SCROLL_CHANGE' = 'AUTO_SCROLL_CHANGE',
    'ON_READY' = 'ON_READY',
    'SETTINGS_RESPONSE' = 'SETTINGS_RESPONSE',
    'REALTIME_SENTIMENT_RESPONSE' = 'REALTIME_SENTIMENT_RESPONSE',
    'PREFS_RESPONSE'='PREFS_RESPONSE',
    'AGENT_ASSIST_CUSTOM_RESPONSE' = 'AGENT_ASSIST_CUSTOM_RESPONSE',
    'AGENTIC_RESPONSE' = 'AGENTIC_RESPONSE'
}

export enum INTERNAL_EVENTS {
    'USER_TRANSCRIPT_MSG' = 'USER_TRANSCRIPT_MSG',
    'AGENT_TRANSCRIPT_MSG' = 'AGENT_TRANSCRIPT_MSG',
    'END_OF_CONVERSATION' = 'END_OF_CONVERSATION',
    'CONVERSATION_SUMMARY_IN_ASSIST' = 'CONVERSATION_SUMMARY_IN_ASSIST',
    'GET_CHECKLISTS' = 'GET_CHECKLISTS',
    'RUN_CLICK_EVENT' = 'RUN_CLICK_EVENT',
    'INTERRUPT_POPUP_EVENT' = 'INTERRUPT_POPUP_EVENT',
    'INTERRUPT_ACCEPT_EVENT' = 'INTERRUPT_ACCEPT_EVENT',
    'INTERRUPT_RUNLATER_EVENT' = 'INTERRUPT_RUNLATER_EVENT',
    'TERMINATE_EVENT' = 'TERMINATE_EVENT',
    'TERMINATE_OVERRIDE_EVENT' = 'TERMINATE_OVERRIDE_EVENT',
    'TEMPLATE_CLICK' = 'TEMPLATE_CLICK',
    'SET_SUMMARY_POPUP' = 'SET_SUMMARY_POPUP',
    'INTERNAL_TRANSFER' = 'INTERNAL_TRANSFER',
    'DISABLE_WIDGET' = 'DISABLE_WIDGET',
    'PAUSE_TRANSCRIPT' = 'PAUSE_TRANSCRIPT',
    'RESUME_TRANSCRIPT' = 'RESUME_TRANSCRIPT',
    'FETCH_TRANSCRIPT' = 'FETCH_TRANSCRIPT',
    'GENERATE_INTERIM_SUMMARY' = 'GENERATE_INTERIM_SUMMARY',
    'IS_SUMMARY_MINIMIZED' = 'IS_SUMMARY_MINIMIZED',
    'CUSTOM_TAB_HISTORY' = 'CUSTOM_TAB_HISTORY',
    'CUSTOM_TAB_DIALOG_WORKFLOW' = 'CUSTOM_TAB_DIALOG_WORKFLOW',
    'SHOW_ALL_DIALOGS' = 'SHOW_ALL_DIALOGS',
    'AGENTIC_START' = 'AGENTIC_START',
    'AGENTIC_END' = 'AGENTIC_END',
    'AGENTIC_REQUEST_ACK' = 'AGENTIC_REQUEST_ACK'
}

export enum EVENTS_TO_SDK {
    UPDATE_ACTIVE_TAB = 'updateActiveTab',
    CHECKLIST_OPEN = 'checklistOpened',
    CHECLIST_RESUME = 'checklistResume',
    CHECKLIST_STEP_CLOSE = 'checklistStepClosed',
    CHECKLIST_PROCEED_TO_CLOSE = 'checklistProceedToClosed'
 }
